import { render, staticRenderFns } from "./StatisticsCompany.vue?vue&type=template&id=01e85698&scoped=true"
import script from "./StatisticsCompany.vue?vue&type=script&lang=js"
export * from "./StatisticsCompany.vue?vue&type=script&lang=js"
import style0 from "./StatisticsCompany.vue?vue&type=style&index=0&id=01e85698&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01e85698",
  null
  
)

export default component.exports